import 'objects/property-forms/PropertyForms.css'
import { Box, type ChipProps } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { propertyFormConfig } from 'objects/property-forms/PropertyFormConfig.tsx'
import { globalCssVars } from '@/core/theme/GlobalCssVars.ts'
import type { PropertyOptionModel } from '@/generated/graphql.ts'

const config = propertyFormConfig

interface MultiSelectOptionChipParams {
  option: PropertyOptionModel
  onOptionsClick?: (e: React.MouseEvent) => void
  onDeselectClick?: (e: React.MouseEvent) => void
  alwaysShowActions?: boolean
  chipProps?: ChipProps
}

export function MultiSelectOptionChip({
  option,
  chipProps,
  onOptionsClick,
  onDeselectClick,
  alwaysShowActions,
}: MultiSelectOptionChipParams) {
  const hasActions = !!onOptionsClick || !!onDeselectClick

  return (
    <Box
      onClick={onOptionsClick ? (e) => { e.stopPropagation(); onOptionsClick(e) } : undefined}
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: option.color,
        color: 'white',
        minWidth: `${config.chipHeightPx * 2}px`,
        borderRadius: globalCssVars.radius3,
        fontSize: '0.8rem',
        height: `${config.chipHeightPx}px`,
        px: 1,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        cursor: onOptionsClick ? 'pointer' : 'default',
        ...(!alwaysShowActions && hasActions && {
          '& .chip-actions': { opacity: 0, transition: 'opacity 0.2s' },
          '&:hover .chip-actions': { opacity: 1 },
        }),
      }}
      {...chipProps}
    >
      <span>{option.value}</span>

      {onDeselectClick && (
        <Box
          className="chip-actions"
          sx={{
            position: 'absolute',
            right: 2,
            top: '50%',
            transform: 'translateY(-50%)',
            display: 'flex',
            opacity: alwaysShowActions ? 1 : 0,
            transition: 'opacity 0.2s',
            backgroundColor: option.color,
            borderRadius: globalCssVars.radius3,
            '& .MuiSvgIcon-root': {
              fontSize: '1rem',
              width: `${config.chipHeightPx}px`,
              height: `${config.chipHeightPx}px`,
              cursor: 'pointer',
            },
          }}
        >
          <CloseIcon
            onClick={(e) => {
              e.stopPropagation()
              onDeselectClick(e)
            }}
          />
        </Box>
      )}
    </Box>
  )
}
